import React from "react";
import Chart from "react-apexcharts";
import { useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../../../../theme";
import { commonColors } from "../../../../theme/colors";

const VerticalStackedBarChart = ({ dataNutritionPerMeal, isDashboard }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const colors = tokens(theme.palette.mode);

  // Extract meal categories for the x-axis
  const categories = dataNutritionPerMeal.map((item) => item.meal);

  // Build series data for each macronutrient
  const series = [
    {
      name: "Protein",
      data: dataNutritionPerMeal.map((item) => item.protein),
    },
    {
      name: "Carbs",
      data: dataNutritionPerMeal.map((item) => item.carbs),
    },
    {
      name: "Fat",
      data: dataNutritionPerMeal.map((item) => item.fat),
    },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      animations: { enabled: true },
      foreColor: "#000", // Forces all default text to be black
    },
    plotOptions: {
      bar: {
        horizontal: false, // Vertical chart
        columnWidth: "55%",
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: isMobile ? "10px" : "12px",
        colors: ["#000"],
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: isMobile ? "10px" : "12px",
          colors: ["#000"],
        },
      },
      title: {
        text: isDashboard ? "" : "Meal",
        style: {
          fontSize: isMobile ? "10px" : "12px",
          color: "#000",
        },
      },
    },
    yaxis: {
      title: {
        text: isDashboard ? "" : "Grams",
        style: {
          fontSize: isMobile ? "10px" : "12px",
          color: "#000",
        },
      },
      labels: {
        style: {
          fontSize: isMobile ? "10px" : "12px",
          colors: ["#000"],
        },
      },
    },
    legend: {
      position: isMobile ? "bottom" : "right",
      horizontalAlign: isMobile ? "center" : "left",
      offsetY: isMobile ? 10 : 0,
      fontSize: isMobile ? "10px" : "12px",
      labels: { colors: ["#000"] },
    },
    grid: { borderColor: "#e0e0e0" },
    tooltip: {
      theme: "dark",
      style: { fontSize: isMobile ? "10px" : "12px", fontFamily: "inherit" },
    },
    colors: [commonColors.protein, commonColors.carbs, commonColors.fat],
    responsive: [
      {
        breakpoint: 600,
        options: {
          plotOptions: { bar: { columnWidth: "65%" } },
          legend: { position: "bottom", offsetY: 10 },
        },
      },
    ],
  };

  return <Chart options={options} series={series} type="bar" height="350" />;
};

export default VerticalStackedBarChart;
